import { fetcher } from '@commenda/utils';

export async function getServicesDescription(
  affiliateFirmId: string,
  itemIds: string[]
): Promise<Response | null> {
  try {
    const res = await fetcher(
      `affiliate-firms/${affiliateFirmId}/quotes/services-descriptions?itemIds=${itemIds.join(
        ','
      )}`,
      {
        method: 'GET',
      }
    );

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
